import { LOCAL_STORAGE_KEYS } from '../../utils/constants';
import { SingleUnit } from './equipmentTypes';

export function getEquipmentReportStatusLabel(report: {
    warnCount?: number | null;
    inopCount?: number | null;
} | null) {
    if (!report) return null;
    const { warnCount, inopCount } = report;
    if ((inopCount || 0) > 0) return { text: `${inopCount} INOP`, className: 'status-critical' };
    if ((warnCount || 0) > 0) return { text: `${warnCount} Warning`, className: 'status-warning' };
    return { text: 'All Good', className: 'status-good' };
}

export function seedSelectedUnitForInspect(unit: SingleUnit) {
    localStorage.setItem(
        LOCAL_STORAGE_KEYS.SELECTED_UNIT,
        JSON.stringify({
            label: unit.description ? `${unit.name} - ${unit.description}` : unit.name,
            value: unit.id,
        }),
    );
}
